import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from '../../lib/toast';
import { API, auth, errMsg } from '../organization/finance/shared';

const VISIBILITY_OPTIONS = [
  { key: 'private', label: 'ملف خاص لا يراه أحد' },
  { key: 'organizations_only', label: 'ظاهر للمنشآت المسجلة فقط' },
  { key: 'public_directory', label: 'ظاهر في الدليل العام' },
];

const Toggle = ({ label, checked, onChange, testId }) => (
  <label className="flex items-center justify-between rounded-lg border border-slate-100 px-4 py-3">
    <span className="text-sm text-slate-700">{label}</span>
    <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} data-testid={testId} className="h-5 w-9 cursor-pointer accent-teal-500" />
  </label>
);

export default function CoachProfilePrivacyTab({ profile, refreshProfile }) {
  const [form, setForm] = useState(profile || {});
  const [saving, setSaving] = useState(false);

  useEffect(() => { setForm(profile || {}); }, [profile]);

  const save = async (overrides) => {
    setSaving(true);
    const payload = { ...form, ...overrides };
    try {
      await axios.put(`${API}/coaches/profile/me/privacy`, {
        profile_visibility: payload.profile_visibility,
        accepts_contact_requests: payload.accepts_contact_requests,
        accepts_job_offers: payload.accepts_job_offers,
        show_city: payload.show_city,
        show_salary_range: payload.show_salary_range,
        show_experiences: payload.show_experiences,
        show_certifications: payload.show_certifications,
      }, auth());
      setForm(payload);
      toast.success('تم حفظ إعدادات الخصوصية');
      refreshProfile?.();
    } catch (err) { toast.error(errMsg(err, 'فشل الحفظ')); }
    setSaving(false);
  };

  return (
    <div className="space-y-5" data-testid="coach-privacy-tab">
      <div className="rounded-2xl border border-slate-200/70 bg-white p-5 shadow-[0_1px_3px_rgba(0,0,0,0.04)]">
        <h3 className="mb-3 text-sm font-bold text-slate-800">ظهور الملف المهني</h3>
        <div className="space-y-2">
          {VISIBILITY_OPTIONS.map((opt) => (
            <label key={opt.key} className="flex items-center gap-2 rounded-lg border border-slate-100 px-4 py-3 text-sm text-slate-700 cursor-pointer">
              <input type="radio" name="visibility" checked={form.profile_visibility === opt.key} onChange={() => save({ profile_visibility: opt.key })} data-testid={`coach-visibility-${opt.key}`} />
              {opt.label}
            </label>
          ))}
        </div>
      </div>

      <div className="rounded-2xl border border-slate-200/70 bg-white p-5 shadow-[0_1px_3px_rgba(0,0,0,0.04)] space-y-2">
        <h3 className="mb-1 text-sm font-bold text-slate-800">استقبال الطلبات والعروض</h3>
        <Toggle label="استقبال طلبات التواصل من المنشآت" checked={Boolean(form.accepts_contact_requests)} onChange={(v) => save({ accepts_contact_requests: v })} testId="coach-toggle-contact-requests" />
        <Toggle label="استقبال عروض العمل" checked={Boolean(form.accepts_job_offers)} onChange={(v) => save({ accepts_job_offers: v })} testId="coach-toggle-job-offers" />
      </div>

      <div className="rounded-2xl border border-slate-200/70 bg-white p-5 shadow-[0_1px_3px_rgba(0,0,0,0.04)] space-y-2">
        <h3 className="mb-1 text-sm font-bold text-slate-800">تفاصيل الملف الظاهرة للعامة</h3>
        <Toggle label="إظهار المدينة" checked={Boolean(form.show_city)} onChange={(v) => save({ show_city: v })} testId="coach-toggle-show-city" />
        <Toggle label="إظهار الخبرات المحددة كظاهرة" checked={Boolean(form.show_experiences)} onChange={(v) => save({ show_experiences: v })} testId="coach-toggle-show-experiences" />
        <Toggle label="إظهار الشهادات مع حالة توثيقها" checked={Boolean(form.show_certifications)} onChange={(v) => save({ show_certifications: v })} testId="coach-toggle-show-certifications" />
        <label className="flex items-center justify-between rounded-lg border border-slate-100 px-4 py-3">
          <span className="text-sm text-slate-700">إظهار نطاق الراتب المتوقع</span>
          <select
            className="rounded-lg border border-slate-200 px-2 py-1 text-sm"
            value={form.show_salary_range || 'hidden'}
            onChange={(e) => save({ show_salary_range: e.target.value })}
            data-testid="coach-select-salary-visibility"
          >
            <option value="hidden">إخفاء تماماً</option>
            <option value="organizations_only">للمنشآت المسجلة فقط</option>
          </select>
        </label>
      </div>
      {saving && <p className="text-xs text-slate-400">جارِ الحفظ...</p>}
    </div>
  );
}
